<template>
  <div>
    <invoice-last-payment-error
      v-if="hasErrorPayment()"
      :invoice="invoice"
      class="mb-3"
    />

    <invoice-summary-card
      :invoice="invoice"
      class="mb-3"
    />

    <invoice-payment-card
      v-if="hasSuccessfulPayment()"
      :invoice="invoice"
    />
  </div>
</template>
<script>
import InvoiceSummaryCard from "../../components/Invoice/InvoiceSummaryCard"
import InvoicePaymentCard from "../../components/Invoice/InvoicePaymentCard"
import { get, isEmpty } from "lodash"
import InvoiceLastPaymentError from "../../components/Invoice/InvoiceLastPaymentError"

export default {
  components: { InvoiceLastPaymentError, InvoicePaymentCard, InvoiceSummaryCard },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    hasErrorPayment() {
      return !isEmpty(get(this.invoice, 'payment_intent.last_payment_error'))
    },
    hasSuccessfulPayment() {
      return this.invoice.status !== 'draft'
        && (get(this.invoice, 'payment_intent.charges.data', []) || []).length > 0
        && isEmpty(get(this.invoice, 'payment_intent.last_payment_error'))
    }
  }

}
</script>
